import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

class SuggestionRemove extends Component {
  static propTypes = {
    translate: PropTypes.func,
    closeModal: PropTypes.func,
    onSubmit: PropTypes.func,
    suggestion: PropTypes.object,
  }

  constructor(props) {
    super(props)

    if (window.innerWidth < 1580) {
      this.state = {
        size: 'sm',
      }
    } else {
      this.state = {
        size: 'xs',
      }
    }
  }

  render() {
    const { size } = this.state
    const { translate, onSubmit, closeModal, suggestion } = this.props

    return (
      <Modal closeModal={closeModal} size={size}>
        <section>
          <Row>
            <Col xs={12}>
              <legend className='margin-top margin-bottom-double'>
                {translate('mobile-update.remove')}
              </legend>
            </Col>
          </Row>

          <Row>
            <Col xs={12} className='margin-bottom-double'>
              <span>{translate('mobile-update.confirm-message-remove')}</span>
            </Col>
          </Row>

          <Row className='margin-top-double margin-bottom'>
            <Col xs={6} md={6}>
              <button
                role='button'
                onClick={closeModal}
                className='button-hollow button-hollow-danger button-full align-center'
              >
                {translate('cancel_button_label')}
              </button>
            </Col>
            <Col xs={6} md={6}>
              <button
                type='button'
                onClick={() => onSubmit(suggestion)}
                className='button button-primary button-full'
              >
                {translate('confirm_button_label')}
              </button>
            </Col>
          </Row>
        </section>
      </Modal>
    )
  }
}

export default SuggestionRemove
